import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function FormButtonGroup(props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '0px',
        gap: '20px',
      }}
    >
      {props.children}
    </Box>
  );
}

FormButtonGroup.propTypes = {
  children: PropTypes.node,
};
